import { FvDate, FvNum } from '@fv/client-components'
import { addressFuncs, totalShipmentWeight } from '@fv/client-core'

import { Loading } from '@/components/Loading'
import { useLoad } from '@/hooks/shipments'
import {
  getDestination,
  getOrigin,
  mapPaymentTerms,
  mapRateType,
  modeNames,
} from '@/utils/shipmentFuncs'

import type { Notification } from '../queries'

type Props = {
  notification: Notification
}
export const NotificationLoadDetails = ({ notification }: Props) => {
  const loadQuery = useLoad(notification.loadId)
  if (!notification.loadId) return null

  if (loadQuery.isLoading) return <Loading />

  if (!loadQuery.data) return null

  const load = loadQuery.data

  const getBookedBy = () => {
    if (!load.bookedBy) return 'na'
    return load.bookedBy.name || 'na'
  }

  const origin = getOrigin({ locations: load.locations })
  const destination = getDestination({ locations: load.locations })

  return (
    <div>
      <p className="mb-0 leading-6">
        <strong>From:</strong>
        <br />
        {origin.company} <br />
        {addressFuncs.streetAddress(origin)} <br />
      </p>
      <div className="border-t border-fv-gray border-dashed my-3" />
      <p className="mb-0">
        <strong>To:</strong>
        <br />
        {destination.company} <br />
        {addressFuncs.streetAddress(destination)} <br />
      </p>
      <div className="border-t border-fv-gray border-dashed my-3" />
      <p>
        {load.tracking?.trackingNumber && (
          <>
            PRO# {load.tracking?.trackingNumber} <br />
          </>
        )}
        {load.pickup?.confirmationNumber && (
          <>
            Pickup Confirmation# {load.pickup?.confirmationNumber} <br />
          </>
        )}
        {origin.refNums?.length && (
          <>
            Shipper# {origin.refNums.map(r => r.value).join(', ')} <br />
          </>
        )}
        {destination.refNums?.length && (
          <>
            PO# {destination.refNums.map(r => r.value).join(', ')} <br />
          </>
        )}
        BOL# {load.bol?.bolNumber} <br />
        Est Pickup: <FvDate val={load.pickupDate} utc /> <br />
        Est Delivery:{' '}
        <FvDate val={load.estimatedDeliveryDate} format="ddd MMM D, YYYY" />{' '}
        <br />
        {modeNames[load.workflow]} / {totalShipmentWeight(load)} lbs <br />
        Quote# {load.selectedQuote?.quoteNum || 'na'} /{' '}
        <FvNum
          currency={load.selectedQuote?.currency}
          val={load.selectedQuote?.amount ?? 0}
          includeEmptyDecimals
        />{' '}
        <br />
        {mapRateType({
          selectedQuote: load.selectedQuote,
          isFreightCollect: load.isFreightCollect,
        })}{' '}
        <br />
        {mapPaymentTerms(load)}
        <br />
        {load.status !== 'pending' && (
          <>
            Booked by {getBookedBy()} <br />
          </>
        )}
      </p>
    </div>
  )
}
